module.exports = __webpack_public_path__ + "static/media/email.47f3bdc8.svg";